/**
 * Analytics postMessage target for gallery + editor surfaces.
 * Matches UploadFloor.js: prefer opener, else parent (S.MPLE webview iframe).
 */
export function getAnalyticsTargetWindow() {
  const near =
    window.opener || (window.parent !== window ? window.parent : null);
  return near && near.parent !== near ? near.parent : near;
}
